import {LogLevel} from '@azure/msal-browser';
import {useNavigator} from '../hooks/useNavigator';
import {CONSTANT_AZURE_TENANT_ID} from '../constants';

const {
  isIE,
  isEdge,
  isFirefox
  // eslint-disable-next-line react-hooks/rules-of-hooks
} = useNavigator();

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_APPLICATION_ID || '',
    authority: `https://login.microsoftonline.com/${CONSTANT_AZURE_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI
  },
  cache: {
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
    cacheLocation: 'sessionStorage',
    secureCookies: true
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            // console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const msalTokenRequest = {
  scopes: ['User.Read']
};

export const msalDefaultRequest = {
  scopes: [...msalTokenRequest.scopes]
};
